import { useQueryClient } from '@tanstack/react-query';

import {
  ContratosActionsKeysEnum,
  EstadosContratoChoiceEnum,
  useIsMediaQuery,
} from '@/shared';
import {
  SuspendCurrentServiceData,
  useUpdateContrato,
} from '@/shared/actions/erp';
import { Contrato } from '@/shared/interfaces';
import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { Button, Grid } from '@mui/material';

export type ClienteFibraBtnsServiceContractProps = {
  contract: Contrato;
};

const ClienteFibraBtnsServiceContract: React.FC<
  ClienteFibraBtnsServiceContractProps
> = ({ contract }) => {
  const isMobile = useIsMediaQuery('sm');
  const queryClient = useQueryClient();

  ///* global state -------------------------
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);

  const onInvalidateQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: [ContratosActionsKeysEnum.CONTRATO],
    });
  };

  ///* mutations -------------------------
  const changeContractService = useUpdateContrato<SuspendCurrentServiceData>({
    enableRedirect: false,
  });
  const activateContractService = useUpdateContrato<SuspendCurrentServiceData>({
    enableRedirect: false,
    customSuccessMessage: 'Servicio activado correctamente',
  });

  ///* handlers -------------------------
  const onSuspend = () => {
    setConfirmDialog({
      isOpen: true,
      title: 'Suspender Servicio',
      subtitle: '¿Está seguro de querer suspender el servicio actual?',
      onConfirm: async () => {
        setConfirmDialogIsOpen(false);
        setIsGlobalLoading(true);
        await changeContractService.mutateAsync({
          id: contract?.id_contrato!,
          data: {
            estado_contrato: EstadosContratoChoiceEnum.SUSPENDIDO,
          },
        });
        await onInvalidateQuery();
        setIsGlobalLoading(false);
      },
    });
  };
  const onActivate = () => {
    setConfirmDialog({
      isOpen: true,
      title: 'Activar Servicio',
      subtitle: '¿Está seguro de querer activar el servicio para este cliente?',
      onConfirm: async () => {
        setConfirmDialogIsOpen(false);
        setIsGlobalLoading(true);
        await activateContractService.mutateAsync({
          id: contract?.id_contrato!,
          data: {
            estado_contrato: EstadosContratoChoiceEnum.ACTIVO,
          },
        });
        await onInvalidateQuery();
        setIsGlobalLoading(false);
      },
    });
  };

  const onDeactivate = () => {
    setConfirmDialog({
      isOpen: true,
      title: 'Desactivar Servicio',
      subtitle: '¿Está seguro de querer desactivar el servicio para este cliente?',
      onConfirm: async () => {
        setConfirmDialogIsOpen(false);
        setIsGlobalLoading(true);
        await activateContractService.mutateAsync({
          id: contract?.id_contrato!,
          data: {
            estado_contrato: EstadosContratoChoiceEnum.INACTIVO,
          },
        });
        await onInvalidateQuery();
        setIsGlobalLoading(false);
      },
    });
  };

  return (
    <Grid item container xs={12} md={6}>
      <Grid
        container
        spacing={isMobile ? 1 : 2}
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item xs={isMobile ? 12 : 'auto'}>
          {(contract.estado_contrato ==
            EstadosContratoChoiceEnum.SUSPENDIDO ||
            contract.estado_contrato ==
            EstadosContratoChoiceEnum.INACTIVO)
            && (
            <Button
              variant="outlined"
              color="info"
              fullWidth={isMobile}
              onClick={() => onActivate()}
              disabled
            >
              ACTIVAR
            </Button>
          )}
        </Grid>

        <Grid item xs={isMobile ? 12 : 'auto'}>
          {contract.estado_contrato ==
            EstadosContratoChoiceEnum.ACTIVO && (
            <Button
              variant="outlined"
              color="warning"
              fullWidth={isMobile}
              onClick={() => onSuspend()}
              disabled
            >
              SUSPENDER
            </Button>
          )}
        </Grid>
        
        <Grid item xs={isMobile ? 12 : 'auto'}>
            <Button
              variant="outlined"
              color="error"
              fullWidth={isMobile}
              onClick={() => onDeactivate()}
              disabled
              // disabled={contract.estado_contrato != EstadosContratoChoiceEnum.INACTIVO? 
              //   false : true}
            >
              Desactivar
            </Button>
        </Grid>

        {/* <Grid item xs={isMobile ? 12 : 'auto'}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth={isMobile}
            onClick={() => {
              alert('CAMBIAR PLAN');
            }}
          >
            CAMBIAR PLAN
          </Button>
        </Grid> */}
      </Grid>
    </Grid>
  );
};

export default ClienteFibraBtnsServiceContract;
